export default "__VITE_PUBLIC_ASSET__64eb4a03__"